import { render } from "./favoris.vue?vue&type=template&id=66f8192d&scoped=true"
import script from "./favoris.vue?vue&type=script&lang=js"
export * from "./favoris.vue?vue&type=script&lang=js"

import "./favoris.vue?vue&type=style&index=0&id=66f8192d&lang=scss&scoped=true"

import exportComponent from "/builds/grxl/cinematech/jmpt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f8192d"]])

export default __exports__